export default {
    "Home": "Para casa",
    "Dashboard": "Painel de controle",
    "Current players total balance": "Saldo total de dispositivos",
    "Total active players count": "Contagem total de dispositivos ativos",
    "Players": "Dispositivos",
    "Players List": "Lista de dispositivos",
    "Back to Players List": "Voltar à lista de dispositivos",
    "Back to Player Detail": "Voltar aos detalhes do dispositivo",
    "Username": "Nome do usuário",
    "Created At": "Criado em",
    "Actions": "Ações",
    "Create": "Criar",
    "Create Player": "Criar dispositivo",
    "New Player": "Novo dispositivo",
    "Activate": "Ativar",
    "Deactivate": "Desativar",
    "View": "Visualizar",
    "Details": "Detalhes",
    "Next": "Próximo",
    "Previous": "Anterior",
    "Filter": "Filtro",
    "Reset": "Claro",
    "Search": "Procurar",
    "Random Username": "Nome do usuário aleatório",
    "Status": "Estado",
    "Active": "Ativo",
    "Inactive": "Inativo",
    "No open withdrawals": "Não há levantamentos abertas",
    "Open Withdrawal": "Abrir Saque",
    "Current player's balance": "Saldo do dispositivo atual",
    "Accept": "Aceitar",
    "Deposit": "Depósito",
    "Balance": "Saldo",
    "Withdraw": "Saque",
    "Withdrawal of": "Saque de",
    "for": "para",
    "of": "de",
    "Amount": "Valor",
    "PIN": "PIN",
    "Games": "Jogos",
    "No Entries": "Não há registros",
    "Change Password": "Alterar a senha",
    "Current Password": "Senha atual",
    "New Password": "Nova senha",
    "New Password Confirmation": "Confirmação de nova senha",
    "Stats": "Estatísticos",
    "Login": "Login",
    "Please activate the player before depositing": "Por favor, ative o dispositivo antes de depositar",
    "History": "História",
    "Type": "Tipo",
    "All": "Tudo",
    "Stats Per Game": "Estatísticas por jogo",
    "Stats Per Device": "Estatísticas por dispositivo",
    "Are you sure you want to deposit - ": "Tem certeza que deseja depositar - ",
    "Are you sure you want to withdraw - ": "Tem certeza que deseja sacar - ",
    "Please show this code to cashier": "Por favor, mostre este código ao caixa",
    "Cancel withdrawal": "Cancelar Saque",
    "and continue playing": "e continue jogando",
    "Withdraw money": "Sacar dinheiro de",
    "Custom Amount": "Quantidade Personalizada",
    "Bingo": "Jogos de bingo",
    "Slot": "Jogos de slots",
    "No game found": "Nenhum jogo encontrado",
    "From": "De",
    "To": "Para",
    "Hold": "Lucro",
    "Bets": "Estacar",
    "Wins": "Vitórias",
    "Game Name": "Nome",
    "Share": "Compartilhar",
    "New Withdrawal": "Novo saque",
    "Logout": "Sair",
    "Spins": "Rotaciona",
    "Stake/Spin": "Estacar/Rotação",
    "Totals": "Total",
    "Save Changes": "Alterações de loja",
    "Save": "Armazenar",
    "Last Login": "Último acesso",
    "Never": "Nunca",
    "Back": "Atrás",
    "Withdrawals": "Retirados",
    "Deposits": "Depósitos",
    "Go Home": "Ir para a página inicial",
    "Back To Lobby": "Voltar ao saguão",
    "Profit": "Saldo",
    "Business Day": "Dia de negócios",
    "Accounting": "Contabilidade",
    "requested a withdrawal": "solicitou uma retirada",
    "canceled a withdrawal": "cancelou um saque",
    "Lobby": "Entrada",
    "Sorry": "Desculpa",
    "Game is not available": "O jogo não está disponível",
    "Game is not available in your current location": "O jogo não está disponível na sua localização atual",
    "Withdrawal error": "Erro de retirada",
    "Insufficient funds": "Fundos insuficientes",
    "Cancel": "Cancelar",
    "Confirm": "Confirme",
    "Withdrawal": "Retirado",
    "Are you sure you want to withdraw all funds?": "Tem certeza de que deseja retirar todos os fundos?",
    "Cancel Withdrawal": "Cancelar Saque",
    "Are you sure you want to cancel withdrawal request?": "Tem certeza de que deseja cancelar o pedido de retirada?",
    "Yes": "Sim",
    "No": "Não",
    "Withdrawal canceled": "Saque cancelada",
    "Please wait": "por favor, aguarde",
    "impersonated as": "personificado como",
    "Force reload": "forçar a recarga",
    "Are you sure you want to reload player page?": "Tem certeza que deseja recarregar a página do jogador?",
    "Summary per location": "Resumo por barra",
    "Summary per operator": "Resumo per gerente de bar",
    "Deposits total sum": "Soma total dos depósitos",
    "Withdrawals total sum": "Soma total das retiradas",
    "Withdrawals pending count": "Contagem de retiradas pendentes",
    "Unlock Withdrawals": "Desbloquear retiradas",
    "Withdrawal confirmation text": "Tem certeza de que deseja desbloquear saques? Todos os jogos abertos serão fechados.",
    "Terminal withdrawals are unblocked": "As retiradas do terminal são desbloqueadas",
    "Withdraw all from player confirmation": "Tem certeza de que deseja retirar o dinheiro dos jogadores?",
    "You have unfinished rounds!": "Você tem rodadas inacabadas!",
    "Open game": "Jogo aberto",
}
